import {
  ElementFormatType,
  FORMAT_ELEMENT_COMMAND,
  LexicalEditor,
} from "lexical";
import React from "react";

import {
  TextLeftIcon,
  TextCenterIcon,
  TextRightIcon,
  TextJustifyIcon,
  TickIcon,
} from "../../../assets/icons/SvgIcons";
import { toolTipConstants } from "../LexicalEditor.types";

export const AlignButton = ({
  alignment = "left",
  editor,
  currentAlignment,
  customClassName,
  ariaLabel,
  isFormat = false,
  readOnly,
  title
}: {
  alignment?: ElementFormatType;
  editor: LexicalEditor;
  currentAlignment?: ElementFormatType | undefined;
  customClassName?: string;
  ariaLabel?: string;
  isFormat?: boolean;
  readOnly?: boolean;
  title?: string;
}) => {
  const isActive = alignment === currentAlignment;

  const getIcon = () => {
    switch (alignment) {
      case "center":
        return <TextCenterIcon />;
      case "right":
        return <TextRightIcon />;
      case "justify":
        return <TextJustifyIcon />;
      case "left":
      default:
        return <TextLeftIcon />;
    }
  };
  return (
    <div
      onClick={() => {
        editor.dispatchCommand(
          FORMAT_ELEMENT_COMMAND,
          isActive ? "left" : alignment
        );
      }}
      title={title}
      className={`lexical-${isFormat ? "formatItem" : "toolbarItem"} ${
        isActive && !isFormat && !readOnly ? "lexical-itemActive" : ""
      } ${customClassName || ""} ${readOnly ? "lexical-readOnly" : ""}`}
      aria-label={ariaLabel}
    >
      {getIcon()}
      {isFormat && (
        <>
          <span>{alignment.charAt(0).toUpperCase() + alignment.slice(1)}</span>
          {isActive && <TickIcon />}
        </>
      )}
    </div>
  );
};

export const Left = ({
  editor,
  isFormat,
  currentAlignment,
  readOnly,
}: {
  editor: LexicalEditor;
  isFormat?: boolean;
  currentAlignment: ElementFormatType | undefined;
  readOnly?: boolean;
}) => (
  <AlignButton
    alignment="left"
    editor={editor}
    currentAlignment={currentAlignment}
    customClassName="lexical-lextoolbarItem"
    ariaLabel="Left Align"
    isFormat={isFormat}
    readOnly={readOnly}
    title={toolTipConstants.leftAlign}
  />
);

export const Center = ({
  editor,
  isFormat,
  currentAlignment,
  readOnly,
}: {
  editor: LexicalEditor;
  isFormat?: boolean;
  currentAlignment: ElementFormatType | undefined;
  readOnly?: boolean;
}) => (
  <AlignButton
    alignment="center"
    editor={editor}
    currentAlignment={currentAlignment}
    customClassName="lexical-lextoolbarItem"
    ariaLabel="Center Align"
    isFormat={isFormat}
    readOnly={readOnly}
    title={toolTipConstants.centerAlign}
  />
);

export const Right = ({
  editor,
  isFormat,
  currentAlignment,
  readOnly,
}: {
  editor: LexicalEditor;
  isFormat?: boolean;
  currentAlignment: ElementFormatType | undefined;
  readOnly?: boolean;
}) => (
  <AlignButton
    alignment="right"
    editor={editor}
    currentAlignment={currentAlignment}
    customClassName="lexical-lextoolbarItem"
    ariaLabel="Right Align"
    isFormat={isFormat}
    readOnly={readOnly}
    title={toolTipConstants.rightAlign}
  />
);

export const Justify = ({
  editor,
  isFormat,
  currentAlignment,
  readOnly,
}: {
  editor: LexicalEditor;
  isFormat?: boolean;
  currentAlignment: ElementFormatType | undefined;
  readOnly?: boolean;
}) => (
  <AlignButton
    alignment="justify"
    editor={editor}
    currentAlignment={currentAlignment}
    customClassName="lexical-lextoolbarItem"
    ariaLabel="Justify Align"
    isFormat={isFormat}
    readOnly={readOnly}
    title={toolTipConstants.justifyAlign}
  />
);

const Alignments = ({
  editor,
  alignment,
  readOnly,
}: {
  editor: LexicalEditor;
  isFormat?: boolean;
  alignment?: ElementFormatType;
  readOnly?: boolean;
}) => {
  return (
    <>
      <Left editor={editor} currentAlignment={alignment} readOnly={readOnly} />
      <Center
        editor={editor}
        currentAlignment={alignment}
        readOnly={readOnly}
      />
      <Right editor={editor} currentAlignment={alignment} readOnly={readOnly} />
      <Justify editor={editor} currentAlignment={alignment} readOnly={readOnly} />
    </>
  );
};

export default Alignments;
